module.exports = __webpack_public_path__ + "static/Elefun_and_Friends-53ea1194309d85f92ce72c593be98bde.jpg";